import { Trans } from '@lingui/macro'
import { FeeAmount } from 'elephantswapv3-sdk'
import Badge from 'components/Badge'
import { formatCompactTVL } from 'hooks/feeTierDistributionUtils'
import { useFeeTierDistribution } from 'hooks/useFeeTierDistribution'
import { PoolState } from 'hooks/usePools'
import React from 'react'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

const Indicators = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

export function FeeTierPercentageBadge({
  feeAmount,
  distributions,
  poolState,
  tvl,
}: {
  feeAmount: FeeAmount
  distributions: ReturnType<typeof useFeeTierDistribution>['distributions']
  poolState: PoolState
  tvl?: number
}) {
  return (
    <Indicators>
      <Badge>
        <ThemedText.DeprecatedLabel fontSize={10}>
          {poolState === PoolState.NOT_EXISTS || poolState === PoolState.INVALID ? (
            <Trans>Not created</Trans>
          ) : distributions?.[feeAmount] !== undefined ? (
            <Trans>{distributions[feeAmount]?.toFixed(0)}% select</Trans>
          ) : (
            <Trans>Loading</Trans>
          )}
        </ThemedText.DeprecatedLabel>
      </Badge>
      {poolState === PoolState.EXISTS && (
        <Badge>
          <ThemedText.DeprecatedLabel fontSize={10}>{formatCompactTVL(tvl)}</ThemedText.DeprecatedLabel>
        </Badge>
      )}
    </Indicators>
  )
}
